import { render, staticRenderFns } from "./CaseConfigPermissions.vue?vue&type=template&id=5fcc847a"
import script from "./CaseConfigPermissions.vue?vue&type=script&lang=js"
export * from "./CaseConfigPermissions.vue?vue&type=script&lang=js"
import style0 from "./CaseConfigPermissions.vue?vue&type=style&index=0&id=5fcc847a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports